import { Modal, ModalBody, ModalContent, ModalHeader } from "@heroui/react";
import { useDisclosure } from "@heroui/react";
import { FaUser, FaUserPlus } from "react-icons/fa6";

interface InvitationTypeSelectionModalProps {
  disclosure: ReturnType<typeof useDisclosure>;
  onSelectType: (type: "existing_renter" | "new_renter" | "cancel") => void;
}

export function InvitationTypeSelectionModal({
  disclosure,
  onSelectType,
}: InvitationTypeSelectionModalProps) {
  const { isOpen, onOpenChange } = disclosure;

  const handleSelectType = (
    type: "existing_renter" | "new_renter" | "cancel",
  ) => {
    onSelectType(type);
    disclosure.onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      size="md"
      onClose={() => handleSelectType("cancel")}>
      <ModalContent>
        <ModalHeader>Выберите тип приглашения</ModalHeader>
        <ModalBody className="pb-6">
          <div className="flex flex-col gap-2">
            <div className="text-sm text-foreground-500">
              Выберите, для кого вы хотите создать приглашение
            </div>

            <div className="grid grid-cols-1 gap-2">
              <div
                className="h-fit flex flex-col gap-2 p-4 border-2 border-foreground-300 rounded-xl cursor-pointer items-center justify-center"
                onClick={() => handleSelectType("existing_renter")}>
                <FaUser className="text-2xl text-primary" />
                <div className="flex flex-col items-center">
                  <span className="font-medium">
                    Для существующего арендатора
                  </span>
                  <span className="text-xs text-foreground-500 text-center">
                    Выберите арендатора из списка
                  </span>
                </div>
              </div>

              <div
                className="h-fit flex flex-col gap-2 p-4 border-2 border-foreground-300 rounded-xl cursor-pointer items-center justify-center"
                onClick={() => handleSelectType("new_renter")}>
                <FaUserPlus className="text-2xl text-primary" />
                <div className="flex flex-col items-center">
                  <span className="font-medium">Для нового арендатора</span>
                  <span className="text-xs text-foreground-500 text-center">
                    Создайте нового арендатора и пригласите его
                  </span>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
